import { saveBlob } from "./saveBlob";

export function saveCsv(csv: string, filename: string): void {
    saveBlob(new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8" }), filename);
}
